<template>
  <main class="haze-widget-full">
    <div class="haze-region-slider" v-if="psi">
        <div class="header">
          <div class="updateon-info">
            <h2>LATEST</h2>
            <div class="updateon show-mobile">{{formattedLastUpdated}}</div>
          </div>
          <div class="tabs">
            <div @click="setActive(region)" v-for="(region,index) in regions" :key="index" :class="['tab', {'active-tab':(activeRegion === region)}]">{{region}}</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="container">
          <div class="row region">
            <h4>24-hr PSI</h4>
            <div class="row-grid-2">
              <div class="psi">
                <div :class="['box', psi[activeRegion].class]">
                  <animated-number
                    :value="psi[activeRegion].value"
                    :formatted="v => v.toFixed()"
                    :animation="{duration: 0.66667}">
                  </animated-number>
                  <div class="label">{{psi[activeRegion].band.label}}</div>
                </div>
              </div>
              <div class="psi-map">
                <div class="sg-map">
                  <img class="map" :alt="activeRegion + ' Singapore'" src="../assets/images/map.png" />
                  <span @click="setActive(region)" v-for="region in regions" :key="region" :class="getRegionClass(region)">
                    {{psi[region].value}}
                  </span>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <div>
            <past-month-chart :data="pastMonth" :active="activeRegion" class="row"></past-month-chart>
            <pm-25-chart :data="pm25" :active="activeRegion" class="row"></pm-25-chart>
            <div class="tips">
                <div class="tip-icon">
                  <img src="../assets/images/lightbulb.svg" alt="lightbulb-icon" />
                </div>
                <div class="tip2-wrapper">
                  <transition name="rotate" v-for="(tip, index) in tips" :key="index">
                    <p class="tip2" v-show="index === tipIndex">{{tip}}</p>
                  </transition>
                </div>
            </div>
            <div class="updateon hide-mobile">{{formattedLastUpdated}}</div>
            <!-- <a class="short-report" target="_self" href="index.html" @click="this.$parent.data.fullversion = !this.$parent.data.fullversion">Show less</a> -->
            <div class="short-report" @click="$emit('toggle-version')">Show less</div>
            <div class="clear"></div>
          </div>
        </div>

    </div>

  </main>
</template>

<script>
import Pm25Chart from './Pm25Chart'
import PastMonthChart from './PastMonthChart'
import AnimatedNumber from './AnimatedNumber'
import {useStore} from '../store'

const MONTHS = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

export default {
  setup () {
    return useStore()
  },
  components: {
    AnimatedNumber,
    Pm25Chart,
    PastMonthChart
  },
  data () {
    return {
      activeRegion: 'North',
      tipIndex: 0
    }
  },
  computed: {
    formattedLastUpdated () {
      if (!this.lastUpdated) return
      const d = new Date(this.lastUpdated)
      d.setHours(d.getHours() + 8)
      let h = d.getUTCHours()
      const isPM = h >= 12
      h = isPM ? h - 12 : h
      h = h === 0 ? 12 : h
      // return `As at ${h}${isPM ? 'pm' : 'am'} on ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`
      return `As at ${h}${isPM ? 'pm' : 'am'} on ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`
    }
  },
  methods: {
    setActive (region) {
      this.$analytics.track('change region', region)
      this.activeRegion = region
    },
    getRegionClass (region) {
      const {activeRegion, psi} = this
      return [
        'psi-region-value',
        region.toLowerCase(),
        {'active-region': activeRegion === region},
        psi[region].class
      ]
    }
  },
  created () {
    setInterval(() => {
      this.tipIndex = (this.tipIndex + 1) % this.tips.length
    }, 5000)
  },
  watch: {
    highest () {
      this.activeRegion = this.highest
    }
  }
}
</script>

<style lang="scss">
$radius: 15px;
$transitiontime: 0.3s;

.haze-widget-full {
  padding: 10px 0;
  box-sizing: border-box;
  * {
    font-family: $font-CuratorRegular;
    font-size: 15px;
  }
  h1, h2, h3, h4 {
    font-family: $font-CuratorBold;
    font-weight: normal;
  }
  h2 {
    line-height: initial;
  }
  .clear {
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
    float: none;
  }
  .hiddden {
    font-size: 0;
    visibility: hidden;
  }
  .row {
    float: none;
    clear: both;
    margin: 20px 0;
    &-grid {
      @include grid_template(1);
      // &-2 { @include grid_template(2); }
      // &-3 { @include grid_template(3); }

      &-2 {
        .psi {
          float: left;
          width: 40%;
        }
        .psi-map {
          float: right;
          width: 60%;
          box-sizing: border-box;
        }
      }

    }
  }
  .health-advisory *, .psi h3 {
    margin: 0;
  }
  .haze-region-slider {
    // padding: 15px;
    .row:first-child {
      margin-top: 0;
    }
    h2 {
      margin: 0;
    }
    .updateon-info {
      position: relative;
      // max-width: 350px;
      h2 {
        display: inline-block;
        font-size: 22px;
        line-height: 28.8px;
      }
      .updateon {
        display: inline-block;
        font-size: 13px;
        line-height: initial;
        margin-left: 10px;
        opacity: 0.5;
      }
    }
    .updateon.hide-mobile {
      // text-align: right;
      opacity: 0.5;
      margin-top: 10px;
      font-size: 13px;
      float: left;
    }
    .tabs {
      @include grid_template(5);
      box-sizing: border-box;
      // max-width: $d_medium;
      margin: 0 auto;
      .tab {
        display: inline-block;
        text-align: center;
        text-transform: uppercase;
        cursor: pointer;
        opacity: 0.4;
        &.active-tab, &:hover {
          opacity: 1;
          transition-duration: $transitiontime;
        }
      }
    }
    .region {
      h4 {
        margin: 0;
        font-size: 15px;
      }
    }
    .short-report {
      font-size: 15px;
      border: 1px solid rgba($black, 0.5);
      cursor: pointer;
      user-select: none;
      color: $black;
      border-radius: $radius;
      outline: none;
      padding: 4px 25px 4px 15px;
      text-decoration: none;
      position: absolute;
      right: 0;
      margin-top: 10px;
      line-height: initial;
      box-sizing: border-box;
      transition: $transitiontime;
      &:after {
        content: '';
        background: url(../assets/images/arrow.svg) no-repeat center;
        background-size: 30%;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 20px;
        height: 100%;
        opacity: 0.5;
        transition: $transitiontime;
        margin-right: 1px;
      }
      &:hover {
        border: 1px solid rgba($black, 1);
        &:after {
          opacity: 1;
        }
      }
    }
    .container {
      @media  (min-width: ($d_medium + 1)) {
        // @include grid_template(2);
        & > *:nth-child(1) {
          float: left;
          width: 30%;
          padding-right: 20px;
          box-sizing: border-box;
        }
        & > *:nth-child(2) {
          float: right;
          width: 70%;
        }
      }
    }
    .box {
      position: relative;
      text-align: center;
      color: #ffffff;
      border-radius: $radius;
      width: 100%;
      max-width: 153px;
      height: 140px;
      transition: $transitiontime;
      h1 {
        font-size: 75px;
        line-height: 104px;
        margin: 0;
        box-sizing: border-box;
        position: relative;
        * {
          font-size: 13px;
          line-height: initial;
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
      }
      .label {
        position: absolute;
        border-radius: 0 0 $radius $radius;
        transition: background $transitiontime;
        font-size: 15px;
        line-height: 24px;
        padding: 6px 0;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    }
    .psi {
      .box {
        
      }
    }
    // .pm25 {
    //   .box {
    //     background: lighten($greydark, 10%);
    //     .label {
    //       background: $greydark;
    //     }
    //   }
    // }
    .tips {
      text-align: center;
      border: 1px solid #8D95A9;
      border-radius: $radius;
      position: relative;
      max-width: 90%;
      margin: 40px auto 0;
      .tip-icon {
        background: #8D95A9;
        border-radius: 100%;
        width: 40px;
        height: 40px;
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        // &:before {
        //   content: '';
        //   border-radius: 50% 50% 0 0;
        //   // background: url('../assets/images/lightbulb.svg') no-repeat center;
        //   display: inline-block;
        //   height: 20px;
        //   width: 20px;
        //   margin-top: 10px;
        // }
        img {
          display: inline;
          width: 50%;
          vertical-align: text-top;
        }
      }
      .tip2-wrapper {
        min-height: 110px;
        position: relative;
        overflow: hidden;
        .tip2 {
          overflow: hidden;
          position: absolute;
          font-size: inherit;
          line-height: 18px;
          width: 90%;
          text-align: center;
          margin: 0;
          top: 50%;
          left: 50%;
          box-sizing: border-box;
          transform: translate(-50%, -50%);

          &.rotate-enter {
            opacity: 0;
            transform: translate(-50%, -100%);
          }

          &.rotate-leave-to {
            opacity: 0;
            transform: translate(-50%, 100%);
          }

          &.rotate-enter-active {
            transition-property: opacity, transform;
            transition-delay: 0.5s;
            transition-duration: 1s;
          }

          &.rotate-leave-active {
            transition-property: opacity, transform;
            transition-duration: 1s;
          }
        }
      }
    }
    .psi-map {
      .sg-map {
        position: relative;
        // margin: 0 auto;
        max-width: 100%;
        transition: $transitiontime;
      }
      .map {
        max-width: 100%;
        display: block;
      }
      .psi-region-value {
        font-family: $font-CuratorRegular;
        border-radius: 100%;
        display: table-cell;
        text-align: center;
        vertical-align: middle;
        width: 30px;
        height: 30px;
        font-size: 13px;
        line-height: 30px;
        position: absolute;
        top: 33%;
        left: 43%;
        cursor: pointer;
        transform: translate(-43%, -33%);
        &.active-region {
          border: 1.5px solid $black;
          font-family: $font-CuratorBold;
        }
        &.north {
          top: 7%;
        }
        &.south {
          top: 60%;
        }
        &.west {
          left: 22%;
        }
        &.east {
          left: 63%;
        }
      }
    }
  }
  .good {
    background: #68a94b;
    color: #ffffff;
    .label {
      background: darken(#68a94b, 15%);
    }
  }
  .moderate {
    background: #6b9dcf;
    color: #ffffff;
    .label {
      background: darken(#6b9dcf, 15%);
    }
  }
  .unhealthy {
    background: #f8d448;
    .label {
      background: darken(#f8d448, 15%);
    }
  }
  .very-unhealthy {
    background: #d4883d;
    color: #ffffff;
    .label {
      background: darken(#d4883d, 15%);
    }
  }
  .hazardous {
    background: #dd5034;
    color: #ffffff;
    .label {
      background: darken(#dd5034, 15%);
    }
  }
  @media (max-width: $d_medium) {
    .haze-region-slider .tabs {
      row-gap: 0px;
      column-gap: 10px;
    }
    .haze-region-slider .tips .tip {
      height: 70px;
      font-size: 13px;
      line-height: 16px;
    }
    .haze-region-slider .psi-map {
      padding-left: 20px;
      .sg-map {
        max-width: 200px;
      }
    }
    .haze-region-slider .updateon-info {
      @include grid_template(2);
      .updateon {
        font-size: 13px;
        text-align: right;
        line-height: inherit;
      }
    }
    .haze-region-slider .box {
      max-width: 150px;
      height: 130px;
    }
    .haze-region-slider .box .label {
      font-size: 14px;
      line-height: 24px;
    }
    .haze-region-slider .short-report {
      font-size: 13px;
      padding: 4px 20px 4px 10px;
      position: relative;
      float: right;
    }
    .hide-mobile {
      display: none;
    }
  }
  @media (max-width: 350px) {
    .haze-region-slider .updateon-info .updateon {
      max-width: 150px;
    }
    .haze-region-slider .tabs {
      display: block;
      text-align: center;
      column-gap: 0;
      .tab {
        padding: 0 2%;
        display: inline-block;
      }
    }
    .haze-region-slider .box {
      max-width: 150px;
      height: 120px;
      h1 {
        font-size: 56px;
        line-height: 86px;
      }
    }
    .haze-region-slider .psi-map .sg-map {
      max-width: 180px;
    }
  }
  @media (min-width: $d_medium + 1) {
    .row-grid-2 .psi .box,
    .haze-region-slider .psi-map .sg-map {
      max-width: 210px;
    }
    .haze-region-slider .psi-map .sg-map {
      margin: 0;
      // padding: 10px;
      box-sizing: border-box;
    }
    // .haze-region-slider .updateon-info h2 {
    //   font-size: 22px;
    //   line-height: 33.6px;
    // }
    .row-grid-2 .psi, .row-grid-2 .psi-map {
      float: none;
      width: 100%;
      margin: 20px 0;
    }
    .haze-region-slider .header {
      margin-bottom: 10px;
      .updateon-info {
        width: 30%;
        float: left;
      }
      .tabs {
        width: 70%;
        float: right;
        .tab {
          padding: 0 4%;
        }
      }
    }
    .haze-region-slider .tips .tip2-wrapper {
      min-height: 100px;
    }
    .show-mobile {
      display: none !important;
    }
  }
  @media (min-width: $d_normal + 1) {
    .haze-region-slider .tips .tip,
    .haze-region-slider .tips .tip2-wrapper {
      min-height: 80px;
    }
  }

  @media (min-width: $d_medium + 1) and (max-width: 650px) {
    .haze-region-slider .container > *:nth-child(1) {
      width: 35%;
    }
    .haze-region-slider .container > *:nth-child(2) {
      width: 65%;
    }
  }
}
</style>
